
import { AssetPreviewFolderController } from './asset-preview-folder.controller'

function assetPreviewFolder () {
  return {
    restrict: 'E',
    templateUrl: '/core/directives/asset-preview-folder/asset-preview-folder.html?$$REVISION$$',

    controller: AssetPreviewFolderController
  }
}
export { assetPreviewFolder }
